import { render } from "./hall.html?vue&type=template&id=47c2df54"
import script from "./Hall.vue?vue&type=script&lang=ts"
export * from "./Hall.vue?vue&type=script&lang=ts"

import "./hall.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script